// src/components/PushNotificationSimulator.js
import React, { useState, useEffect, useRef } from "react";
import { useApp } from "../context/AppContext";
import Toast from "./Toast";
import { AnimatePresence } from "framer-motion"; // <-- Importamos AnimatePresence

const PushNotificationSimulator = () => {
  const { transactions } = useApp();
  const [toastTransaction, setToastTransaction] = useState(null);
  const processedNotifications = useRef(new Set());

  useEffect(() => {
    if (!transactions || transactions.length === 0) return;

    const latestTx = transactions[0];
    const txId = latestTx.id || latestTx.reference || Math.random().toString(); 
    const origin =
      latestTx.origin_country_code ||
      latestTx.origin_country ||
      latestTx.originCountry ||
      "origen";
    const destination =
      latestTx.destination_country_code ||
      latestTx.destination_country ||
      latestTx.destinationCountry ||
      "destino";

    if (!processedNotifications.current.has(`${txId}-new`)) {
      console.log(
        `[ADMIN NOTIFICATION] Nueva orden de ${latestTx.amount} ${origin} a ${destination}.`
      );
      processedNotifications.current.add(`${txId}-new`);
    }

    const statusKey = `${txId}-${latestTx.status}`;
    
    // Asegúrate de tener "Procesando" aquí
    if (
      ["Completado", "Cancelado", "Procesando"].includes(latestTx.status) &&
      !processedNotifications.current.has(statusKey)
    ) {
      setToastTransaction(latestTx);
      processedNotifications.current.add(statusKey);
    }
  }, [transactions]);

  return (
    // AnimatePresence permite animar la salida del Toast
    <AnimatePresence>
      {toastTransaction && (
        <Toast
          key={toastTransaction.id || "toast-alert"} // Clave única necesaria para AnimatePresence
          transaction={toastTransaction}
          onClose={() => setToastTransaction(null)}
        />
      )}
    </AnimatePresence>
  );
};

export default PushNotificationSimulator;